import { render, staticRenderFns } from "./drugList.vue?vue&type=template&id=5ba3b4f1&scoped=true&"
import script from "./drugList.vue?vue&type=script&lang=js&"
export * from "./drugList.vue?vue&type=script&lang=js&"
import style0 from "./drugList.vue?vue&type=style&index=0&id=5ba3b4f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3b4f1",
  null
  
)

export default component.exports